<div class="carousel" (click)="close()">
  <div class="carousel-image-container" (click)="close()">
    <span class="helper"></span><img class="picture" [@slide-in]="animState" (@slide-in.done)="animDone()" [src]="images[animImage].path" (click)="doNothing()">
  </div>
  <img class="carousel-close" src="./assets/icon/cross.svg" tabindex="3" (keyup.enter)="close()">
  <img class="navigation-button left-arrow" src="./assets/icon/arrow_back.svg" tabindex="1" (keyup.enter)="previous($event)" (click)="previous($event)">
  <img class="navigation-button right-arrow" src="./assets/icon/arrow_forward.svg" tabindex="2" (keyup.enter)="next($event)" (click)="next($event)">
</div>
